// extracted by mini-css-extract-plugin
module.exports = {"links":"links__q4gPM","modal":"modal___Qp9R","header":"header__3kwiG","button":"button__21Y-Z","burger":"burger__1aaid","line":"line__1yYNE","link":"link__x1Js7"};